
import { Card, CardContent, Grid,  Divider } from "@mui/material";
import { ExamProps } from "./Exam";
import CardHeader from "./layouts/CardHeader";
import CountChips from "./layouts/CountChips";
import CardFooter from "./layouts/CardFooter";
import { EllipsisText } from "./Goal";


function Section({
  data,
  onclick,
  tempSelected,
  setCardsSelected,
  cardsSelected,child
}: any) {
  const tempS = data.id === tempSelected?.data.id;
  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: tempS ? 4 : "none",
        transform: tempS ? "scale(1.01)" : "none",
        border: tempS ? "2px dashed #519C66" : "2px dashed #ccc",
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          boxShadow: 4,
          transform: "scale(1.01)",
          border: "2px dashed #519C66",
        },
        pointerEvents: tempS ? "none" : "auto",
      }}
      onClick={onclick}
    >
      <CardContent>
        <CardHeader
            onClick={onclick}
            selected={child?true:false}
          name={data.name}
          description={data.description}
          id={data.id}
          status={data.status}
          is_active={data.is_active}
        />

        {/* Stats */}
        <Grid container spacing={2} mb={2}>
          <Grid item xs={6} sm={2}>
            <CountChips
              label="Units"
              value={data.total_units}
              color="#f3e8ff"
              onClick={
                tempS && cardsSelected.goal && cardsSelected.section
                  ? () => {
                      if (cardsSelected.unit) {
                        setCardsSelected({
                          unit: false,
                          topic: false,
                          subtopic: false,
                          cluster: false,
                          question: false,
                        });
                      } else {
                        setCardsSelected({
                          unit: true,
                        });
                      }
                    }
                  : undefined
              }
              selected={tempS ? cardsSelected.unit : false}
              text="#7c3aed"
            />
          </Grid>
          <Grid item xs={6} sm={2}>
            <CountChips
              label="Topics"
              value={data.total_topics}
              onClick={
                tempS &&
                cardsSelected.goal &&
                cardsSelected.section &&
                cardsSelected.unit
                  ? () => {
                      if (cardsSelected.topic) {
                        setCardsSelected({
                          topic: false,
                          subtopic: false,
                          cluster: false,
                          question: false,
                        });
                      } else {
                        setCardsSelected({
                          topic: true,
                        });
                      }
                    }
                  : undefined
              }
              selected={tempS ? cardsSelected.topic : false}
              color="#dcfce7"
              text="#16a34a"
            />
          </Grid>
          <Grid item xs={6} sm={2}>
            <CountChips
              label="Subtopics"
              onClick={
                tempS &&
                cardsSelected.goal &&
                cardsSelected.section &&
                cardsSelected.unit &&
                cardsSelected.topic
                  ? () => {
                      if (cardsSelected.subtopic) {
                        setCardsSelected({
                          subtopic: false,
                          cluster: false,
                          question: false,
                        });
                      } else {
                        setCardsSelected({
                          subtopic: true,
                        });
                      }
                    }
                  : undefined
              }
              selected={tempS ? cardsSelected.subtopic : false}
              value={data.total_subtopics}
              color="#eef2ff"
              text="#4f46e5"
            />
          </Grid>
          <Grid item xs={6} sm={2}>
            <CountChips
              label="Clusters"
              value={data.total_clusters}
              onClick={
                tempS &&
                cardsSelected.goal &&
                cardsSelected.section &&
                cardsSelected.unit &&
                cardsSelected.topic &&
                cardsSelected.subtopic
                  ? () => {
                      if (cardsSelected.cluster) {
                        setCardsSelected({
                          cluster: false,
                          question: false,
                        });
                      } else {
                        setCardsSelected({
                          cluster: true,
                          question: true,
                        });
                      }
                    }
                  : undefined
              }
              selected={tempS ? cardsSelected.cluster : false}
              color="#e0f2fe"
              text="#0284c7"
            />
          </Grid>
          <Grid item xs={6} sm={2}>
            <CountChips
              label="Questions"
              selected={tempS ? cardsSelected.question : false}
              value={data.total_questions}
              color="#fee2e2"
              text="#dc2626"
            />
          </Grid>
          <Grid item xs={6} sm={2}>
            <CountChips
              label="Weightage"
              value={data.weightage ? `${data.weightage}%` : "-"}
              color="#fef3c7"
              text="#d97706"
            />
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />
        {/* Details */}
          <Grid container spacing={2} mb={2}>
                  <Grid item  xs={12} sm={6} md={6}>
                    <EllipsisText label="Path Order:" value={data.path_order} /><EllipsisText
                      label="Languages:"
                      value={data.languages_available
                ? data.languages_available
                    .split(",")
                    .map((lang: string) => lang.trim())
                    .join(", ")
                : "-"}
                    />
                  </Grid> <Grid item  xs={12} sm={6} md={6}>
           <EllipsisText label="Show Translation:" value={data.show_translation ? "Yes" : "No"}/>
            
           <EllipsisText label="Free Access:" value={data.is_free ? "Yes" : "No"}/> 
          </Grid>

         

           
        </Grid> <CardFooter
          internal_remark={data.internal_remark}
          created_at={data.created_at}
          created_by_id={data.created_by_id}
          modified_at={data.modified_at}
          modified_by_id={data.modified_by_id}
        />
      </CardContent> {child}
    </Card>
  );
}

// Stat Box
// function Stat({
//   label,
//   value,
//   color = "#f9fafb",
//   text = "#1f2937",
// }: {
//   label: string;
//   value: number | string;
//   color?: string;
//   text?: string;
// }) {
//   return (
//     <Box
//       sx={{
//         background: color,
//         borderRadius: 2,
//         p: 1.5,
//         textAlign: "center",
//       }}
//     >
//       <Typography variant="h6" fontWeight={600} sx={{ color: text, ...ellipsisStyle }}>
//         {value}
//       </Typography>
//       <Typography variant="caption" color="text.secondary" sx={ellipsisStyle}>
//         {label}
//       </Typography>
//     </Box>
//   );
// }

export default Section;
